export enum SituacaoGestorConvite {
    EmEdicao = 1,
    Enviado = 2,
    Aceito = 3,
    Rejeitado = 4,
    Expirado = 5
}
